function convertToSlug(Text) {
  return encodeURI(Text);
}

const Helper = {
  convertToSlug: convertToSlug
};

export default Helper;
